import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class FreeDataLevel extends BasicEntity {
code: string;
description: TranslatedEmb;
fdid: number | null;
freedataCode: string;
label: TranslatedEmb;
level: number | null;
}

